import { AxiosResponse } from 'axios';

import { customAxios } from '../index';

interface Response<T> {
  data: T;
  status: {
    code: string;
    message: string;
  };
}

// 取得所有Reserved ProfileId
const getReservedProfileIdAPI = (): Promise<AxiosResponse<Response<string[]>>> =>
  customAxios.get('/hktv_koc/cms/reserved_profile_id');
// 更改所有Reserved ProfileId
const putReservedProfileIdAPI = (data: string[]) =>
  customAxios.put('/hktv_koc/cms/reserved_profile_id', data);

export { getReservedProfileIdAPI, putReservedProfileIdAPI };
